import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStorifyComponent } from './simple-icons-storify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStorifyComponent ],
    exports:      [ SimpleIconsStorifyComponent ],
    bootstrap:    []
})
export class SimpleIconsStorifyModule {}
